import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Views } from '@appTypes/Spreadsheet';

export type SaveViewsFunction = ( views: Views ) => Promise<void>;

interface SaveViewsActionState {
  saveViewsFunction: SaveViewsFunction | null;
}

const initialState: SaveViewsActionState = {
  saveViewsFunction: null
};

export const saveViewsActionSlice = createSlice({
  name: 'saveViewsAction',
  initialState,
  reducers: {
    setSaveViewsFunction: ( state, action: PayloadAction<SaveViewsFunction | null> ) => {
      state.saveViewsFunction = action.payload;
    },
    resetSaveViewsFunction: ( state ) => {
      state.saveViewsFunction = null;
    }
  }
});

export const { setSaveViewsFunction, resetSaveViewsFunction } = saveViewsActionSlice.actions;

// Selector to get the save views function
export const selectSaveViewsFunction = ( state: { spreadsheet: { saveViewsAction: SaveViewsActionState }}) => {
  return state.spreadsheet.saveViewsAction.saveViewsFunction;
};

export default saveViewsActionSlice.reducer;
